import styled from 'styled-components';
import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import { IconWrapper } from '@deprecated-ui/common/Iconmoon';
import BaseAutocomplete from '@deprecated-ui/common/Autocomplete';
import color from '@deprecated-ui/_style/color';

const Relative = styled.div`
  position: relative;
  background: ${color.light};
`;

const CatalogItem = styled(Text).attrs({ size: '13px', p: '2px 8px' })`
  border-radius: 999px;
  border: 1px solid ${color.primary};
  color: ${color.primary};
  width: fit-content;
  display: inline-flex;
  font-size: 12.5px;

  :hover {
    background: ${color.primary};
    color: ${color.light};
  }
`;

const SearchBarWrapper = styled(Flex)`
  display: ${(props) =>
    // @ts-expect-error
    (props?.isVisible ? 'flex' : 'none')};
  background: ${color.light};
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 15px 16px;
  z-index: 2;
`;

const IconClose = styled(IconWrapper)`
  border: 1px solid ${color.lowgray};
  background: ${color.light};
  border-left: none;
  border-radius: 2px;
`;

const Autocomplete = styled(BaseAutocomplete)`
  /* .rc-virtual-list-holder-inner {
    flex-direction: row;
    flex-wrap: wrap;
  } */

  .ant-select-item-option-grouped {
    padding-left: 12px;
  }

  .ant-select-item-group {
    &:not(:first-child) {
      border-top: dashed 1px ${color.gainsboro};
    }

    border-bottom: solid 1px #f0f0f0;
    font-size: 14px;
    color: ${color.dimgray};
    width: 100%;
  }

  .ant-select-item-option {
    width: 100%;
    align-items: center;
  }

  .catalog-res {
    background: #fff;
    padding: 12px;

    &:hover,
    &:focus {
      background: #fff;
    }
  }
`;

const NavLink = styled.div`
  display: flex;
  align-items: center;
`;

export {
  CatalogItem,
  Relative,
  SearchBarWrapper,
  IconClose,
  Autocomplete,
  NavLink,
};
